import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { initTheme, Toaster, TooltipProvider } from '@enp/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createAppRouter } from './router.js';
import './app.css';

initTheme();
const { router, queryClient, keeper } = createAppRouter();
keeper.start();

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={300}>
        <RouterProvider router={router} />
        {/* Top centre, over the top bar's empty middle: never over a page's controls, its
            sticky action bars (UI4A-216) or the rows under them (UI6A-114, app-wide). */}
        <Toaster position="top-center" offset={{ top: 8 }} />
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);
